import { ListProps } from '@repo/ui';

import { NotificationTermKey } from '@/lib/types/auth';

export const COMMON_APPLY_TERMS_OF_SERVICE_KEY = {
  고유식별정보수집이용동의: 'bznav-taxrefund-unique-identification'
};

export const REFUND_RESULT_TERMS_OF_SERVICE_KEY = {
  경정청구업무위임동의: 'bznav-taxrefund-delegation',
  신용정보제3자제공동의: 'bznav-taxrefund-private-3rdagree',
  경정청구업무권한위임장: 'bznav-taxrefund-delegation-contract'
};

export const TERMS_OF_SERVICE_KEY = {
  서비스이용약관동의: 'bznav-taxrefund-service',
  고유식별정보입력동의: 'bznav-taxrefund-unique-identification-input',
  국세청개인정보이용동의: 'bznav-taxrefund-nts-private',
  국세청제3자정보제공동의: 'bznav-taxrefund-nts-3rdagree',
  개인정보수집이용동의: 'bznav-taxrefund-marketing',
  광고성정보수신동의: 'bznav-taxrefund-advertising',
  제3자개인법인신용정보제공동의: 'bznav-taxrefund-3rdagree',
  개인및법인신용정보수집이용동의: 'bznav-taxrefund-collection-indis-corps'
};

export const NOTIFICATION_TERMS: {
  key: NotificationTermKey;
  title: string;
  description?: string;
  size: ListProps['size'];
  termKey: string | null;
}[] = [
  {
    key: 'all',
    title: '혜택·이벤트 정보 알림',
    description: '다양한 혜택과 이벤트 소식을 알려드릴게요.\n알림을 꺼도 중요한 환급 정보는 받을 수 있어요.',
    size: 'large',
    termKey: null
  },
  {
    key: 'marketing',
    title: '개인정보 수집·이용 동의(마케팅)',
    size: 'small',
    termKey: 'bznav-taxrefund-marketing'
  },
  {
    key: 'advertising',
    title: '광고성 정보수신 동의',
    size: 'small',
    termKey: 'bznav-taxrefund-advertising'
  }
];

export const HECTO_TERMS = [
  { key: 'hecto-service', title: '[필수] 전자금융거래 이용약관' },
  { key: 'hecto-collection', title: '[필수] 개인정보 수집·이용' },
  { key: 'hecto-3rdagree', title: '[필수] 개인정보 제3자 제공 및 위탁 안내' }
];
